import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ArrowRight = function ArrowRight(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 12.2227C22.3125 11.8467 22.1514 11.46 21.8828 11.2021L14.8574 4.17676C14.5566 3.87598 14.2129 3.73633 13.8691 3.73633C13.0742 3.73633 12.5156 4.30566 12.5156 5.04688C12.5156 5.45508 12.6875 5.77734 12.9346 6.03516L15.373 8.48438L18.0908 10.9766L15.6738 10.8477H3.09473C2.24609 10.8477 1.67676 11.4062 1.67676 12.2227C1.67676 13.0391 2.24609 13.5977 3.09473 13.5977H15.6738L18.0908 13.458L15.373 15.9609L12.9346 18.3994C12.6875 18.6572 12.5156 18.9795 12.5156 19.3877C12.5156 20.1396 13.0742 20.6982 13.8691 20.6982C14.2129 20.6982 14.5459 20.5586 14.8359 20.2686L21.8828 13.2432C22.1514 12.9746 22.3125 12.5986 22.3125 12.2227Z"
  })));
};

ArrowRight.displayName = 'ArrowRight';
export default ArrowRight;